/**
 * Environment configuration utility
 * Centralizes access to environment variables with proper defaults and type conversion
 */

export const env = {
  // API Configuration
  API_BASE_URL: import.meta.env.VITE_API_BASE_URL || '',
  WS_BASE_URL: import.meta.env.VITE_WS_BASE_URL || '',
  
  // Auto-summary Configuration
  AUTO_SUMMARY_INTERVAL: parseInt(import.meta.env.VITE_AUTO_SUMMARY_INTERVAL) || 10000,
  MIN_TEXT_LENGTH_FOR_SUMMARY: parseInt(import.meta.env.VITE_MIN_TEXT_LENGTH_FOR_SUMMARY) || 150,
  
  // Development flags
  IS_DEV: import.meta.env.DEV,
  IS_PROD: import.meta.env.PROD,

  // Demo mode — password-only gate, AWS-backed features hidden.
  // Enabled at build time via VITE_DEMO_MODE=true.
  IS_DEMO: import.meta.env.VITE_DEMO_MODE === 'true',
}

/**
 * Get the WebSocket URL for STT connection
 * @returns {string} WebSocket URL
 */
export const getWebSocketUrl = () => {
  if (env.WS_BASE_URL) {
    return `${env.WS_BASE_URL}/ws/stt`;
  }
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//${window.location.host}/ws/stt`;
}

/**
 * Get the API endpoint URL
 * @param {string} endpoint - The API endpoint path
 * @returns {string} Full API URL
 */
export const getApiUrl = (endpoint) => {
  if (env.API_BASE_URL) {
    return `${env.API_BASE_URL}${endpoint}`;
  }
  return endpoint; // Rely on Vite proxy in development
}

/**
 * Log environment configuration (useful for debugging)
 */
export const logEnvConfig = () => {
  if (env.IS_DEV) {
    console.log('🔧 Environment Configuration:', {
      API_BASE_URL: env.API_BASE_URL || 'Using Vite proxy',
      WS_BASE_URL: env.WS_BASE_URL || 'Using window.location.host',
      AUTO_SUMMARY_INTERVAL: env.AUTO_SUMMARY_INTERVAL,
      MIN_TEXT_LENGTH_FOR_SUMMARY: env.MIN_TEXT_LENGTH_FOR_SUMMARY,
    });
  }
}